import { useQuery } from '@tanstack/react-query';
import { getDoctorVerificationStats } from '../../services/doctor-verification';
import { VERIFICATION_STATUS } from '../../constants';
import { IconDiscountCheck, IconDiscountCheckFilled, IconEmpathizeOff } from '@tabler/icons-react';
import colors from '../../constants/colors';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

export const useDoctorVerificationStats = (role: string, doctorVerificationSelectedTab: number) => {
  const { t } = useTranslation();

  const { data: statsData, isLoading } = useQuery({
    queryKey: ['doctor-verification-stats', role, doctorVerificationSelectedTab],
    queryFn: () => getDoctorVerificationStats(role),
    enabled: Boolean(role),
    placeholderData: (previousData) => previousData,
    staleTime: 0 //  force refetch on tab change
  });

  // Transform stats into cards format
  const doctorVerificationStats = useMemo(() => {
    if (!statsData) return [];

    return [
      {
        count: statsData.pendingVerification?.aggregate?.count,
        label: t('verificationRequests'),
        status: VERIFICATION_STATUS.PENDING,
        icon: <IconDiscountCheck size={15} color={colors.blueDarkText} stroke={1} />,
        lowerLabel: t('pendingVerificationsCount')
      },
      {
        count: statsData.verifiedPractices?.aggregate?.count,
        label: t('doctorsVerified'),
        status: VERIFICATION_STATUS.VERIFIED,
        icon: <IconDiscountCheckFilled size={15} color={colors.blueBase} stroke={1} />,
        lowerLabel: t('toDoVerified')
      },
      {
        count: statsData.reVerification?.aggregate?.count,
        label: t('doctorsOnReverification'),
        status: VERIFICATION_STATUS.UPDATE_REQUESTED,
        icon: <IconEmpathizeOff size={15} color={colors.iconDarkRed} stroke={1} />,
        lowerLabel: t('toDoreverification')
      },
      {
        count: statsData.rejectedVerification?.aggregate?.count,
        label: t('verificationRejected'),
        status: VERIFICATION_STATUS.REJECTED,
        icon: <IconEmpathizeOff size={15} color={colors.iconDarkRed} stroke={1} />,
        lowerLabel: t('profileRejected')
      }
    ];
  }, [statsData, t]);

  return { doctorVerificationStats, isLoading, doctorVerificationSelectedTab };
};
